import { useEffect, useRef } from "react";
import { useMotionValue, type MotionValue } from "motion/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Hero-only replacement for useScatterProgress: same { ref, scrollYProgress }
// shape (0 as the hero's top hits the viewport top, 1 once its bottom does),
// but driven by GSAP ScrollTrigger's single shared ticker instead of a
// dedicated Framer Motion useScroll subscription per hero.
export function useHeroScrollFX(): { ref: React.RefObject<HTMLDivElement>; scrollYProgress: MotionValue<number> } {
  const ref = useRef<HTMLDivElement>(null);
  const scrollYProgress = useMotionValue(0);

  useEffect(() => {
    if (!ref.current) return;
    const trigger = ScrollTrigger.create({
      trigger: ref.current,
      start: "top top",
      end: "bottom top",
      scrub: true,
      onUpdate: (self) => scrollYProgress.set(self.progress),
    });
    return () => trigger.kill();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { ref, scrollYProgress };
}
